import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import {EventBus} from "@/helpers/EventBus";

import './app.css'

import vueNumeralFilterInstaller from 'vue-numeral-filter';

Vue.prototype.$eventBus = EventBus;

Vue.use(vueNumeralFilterInstaller);
Vue.use(require('vue-moment'));

const language = localStorage.getItem('lang');
if (language) {
  i18n.locale = language;
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
